// exports

export const Shadows = {
	normal: '0 0.2rem 0.4rem 0.2rem rgba(37, 37, 58, 0.1)',
	hover: '0 0.4rem 0.8rem 0.4rem rgba(37, 37, 58, 0.1)'
};
